import {
  AvailableBasePathTypes,
  AvailableCountryNameTypes,
} from './../../types/common';
import { AvailableGridTypes } from './../../types/category/categoryTypes';
export const QUICKSILVER_FEATURES_COOKIE = 'QUICKSILVER_FEATURES';

export const CRM_COOKIES_CONSENT_KEY = 'cdb';

export const GAMING_ROLLOUT_COOKIE_NAME = 'vegas-migration';

export const VERTICALS_FOR_SIMPLIFIED_ROLLOUT_TRACKING = ['Poker'];

export const VERTICALS_WITH_ROLLOUT_ENABLED = ['poker', 'bingo'];

export const GAMING_SEGMENTS_COOKIE_NAME = 'vegas-segments';

export const PERSONALIZATION_COOKIE_NAME = 'x-force-personalization';

export const MAXIMUM_BANNER_SIZE_NO_NAVIGATION = 1340;
export const MAXIMUM_BANNER_SIZE_WITH_NAVIGATION = 990;

export const BASE_PATH_TO_COUNTRY_NAME_MAP: {
  [key in AvailableBasePathTypes]: AvailableCountryNameTypes;
} = {
  'en-gb': 'United Kingdom',
  'en-ca': 'Canada',
  'en-ie': 'Ireland',
  'de-at': 'Austria',
  'ja-jp': 'Japan',
  'ru-ru': 'Russia',
};

export const CHUNK_SIZE_MAP: {
  [key in AvailableGridTypes]: { normal: number; big: number };
} = {
  'Jackpot Nine': {
    normal: 9,
    big: 9,
  },
  'Game Dual': {
    normal: 5,
    big: 6,
  },
  'Game Banner': {
    normal: 4,
    big: 7,
  },
  'Game List': {
    normal: 4,
    big: 8,
  },
  'Widget Banner': {
    normal: 3,
    big: 6,
  },
  'Jackpot Banner': {
    normal: 3,
    big: 6,
  },
  'Widget Hero': {
    normal: 5,
    big: 6,
  },
  'Jackpot Hero': {
    normal: 5,
    big: 6,
  },
  'Single Block': {
    normal: 3,
    big: 6,
  },
  'Extended Single Block': {
    normal: 3,
    big: 6,
  },
  Grid: {
    normal: 3,
    big: 6,
  },
  'Dynamic Grid': {
    normal: 12,
    big: 12,
  },
  Collection: {
    normal: 12,
    big: 12,
  },
  Banner: {
    normal: 1,
    big: 1,
  },
};

export const HOMEPAGE_BASE_PATH = '/';

export const CONTEXT_ATTRIBUTES = [
  'agent',
  'segments',
  'source',
  'game_sub_category',
  'game_top_category',
];

export const WEB_ATTRIBUTES = [
  'agent',
  'segments',
  'game_sub_category',
  'game_top_category',
];

export const MOBILE_DEVICES = ['mobile', 'tablet'];
